import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";

import { Row, Col, Tooltip, Collapse } from"antd";
import {ArrowLeftOutlined, SaveOutlined, SaveTwoTone, WarningOutlined} from '@ant-design/icons';
import {routePath} from "../../router/paths";

import {
  clearRequestDetails,
  downloadFileFromArchive,
  downloadFileFromRequest
} from "../../store/request-details/actions";
import moment from "moment";
import {DATE_FORMAT_YEAR, DATETIME_FORMAT_FULL} from "../../utils/constants";

const RequestDetails = (props) => {
  const dispatch = useDispatch();
  const { Panel } = Collapse;

  const requestDetails = useSelector((state) => state.requestDetails);
  const user = useSelector((state) => state.user);

  useEffect(()=>{

    return ()=>{
      dispatch(clearRequestDetails());
    }
  },[])

  useEffect(()=>{
      if(requestDetails && requestDetails.payload === null){
        props.history.push({
          pathname: routePath.REQUEST_LIST,
          state: {backPath: props.history.location.pathname}
        });
      }
    }
    ,[requestDetails])

  const downloadHandler =(spSiteUrl, spFolderServerRelativeUrl, fileName)=>{
    console.log("DOWNLOAD");
    dispatch(downloadFileFromRequest(spSiteUrl,spFolderServerRelativeUrl, fileName));
  }

  const downloadFromArchiveHandler =(documentDownloadUrl, fileName)=>{
    console.log("DOWNLOAD ARCHIVE");
    dispatch(downloadFileFromArchive(documentDownloadUrl, fileName));
  }


  function callback(key) {
    console.log(key);
  }

  const info = requestDetails && requestDetails.payload && requestDetails.payload.data;

  const fileTypeToTextConverter = (type) => {
    if (type.includes("p7s")) return <p className="file-type">Файл підпису Електронного нотаріального запиту:</p> ;
    if (type.includes("10.1.1")) return <p className="file-type">Електронний нотаріальний запит:</p>;
    if (type.includes("10.1.2")) return <p className="file-type">Документ, що підтверджує відповідний статус по вкладнику (померлий/БВО/ОЗБОО):</p>;
    if (type.includes("10.1.3")) return <p className="file-type">Ощадна книжка:</p>;
    if (type.includes("10.1.4")) return <p className="file-type">Інший документ нотаріального запиту:</p>;
    return null;
  }

  return (
    <div className="details-container">
      {console.log("requestDetails", requestDetails)}
      <div className="top-container">
        <Tooltip title='Повернутися назад'
                 placement='bottom'>
          <button type='button'
                  className='datas-btn datas-btn-icon datas-btn-yellow'
                  style={{maxHeight: "36px"}}
                  onClick={() => {
                    dispatch(clearRequestDetails());
                    props.history.push({pathname: routePath.REQUEST_LIST})
                  }
                  }
          >
            <ArrowLeftOutlined />
          </button>
        </Tooltip>
        <p>ID: {info && info.processInfo && info.processInfo.requestId}</p>
      </div>
      <Row className="request-details ant-form ant-form-horizontal">
        {
          info && info.archive && info.archive.result && info.archive.result.errorMessage &&
          <Col md={14} style={{display:"flex", flexDirection:"column", alignItems:"center"}}>
            <h2><WarningOutlined style={{color: "#ee4b52", fontSize: "2rem", marginRight:"0.5rem"}} />Помилка</h2>
            <p style={{textAlign:"center", fontSize:'1rem'}}>{info.archive.result.errorMessage}</p>
          </Col>
        }

        <Col md={14} >
          <Collapse
            defaultActiveKey={['1','2']}
            bordered={false}
            onChange={callback}
            ghost={true}
          >
            {info?.packageOut?.files && <Panel header="Відповідь на нотаріальний запит" key="1" className="panel1" style={{fontSize: "20px"}}>
              {info?.packageOut?.files?.map(item => {
                return <dl>
                  <dd>Відповідь на запит:</dd>
                  <dt style={{display: "flex", flexDirection: "row", border: "none"}}>
                    <p style={{marginBottom: "0px"}}>
                      {
                        item && item.fileInfo && item.fileInfo.fileName
                      }
                    </p>
                    <Tooltip title="Завантажити файл" placement="right" color="#DCE123">
                      <div className='download-button'
                           onClick={() => downloadHandler(
                             info?.packageOut?.spSiteUrl,
                             info?.packageOut?.spFolderServerRelativeUrl,
                             item?.fileInfo?.fileName)}>
                        <SaveOutlined style={{fontSize: "1rem"}}/>
                      </div>
                    </Tooltip>
                  </dt>
                </dl>
              })}
            </Panel>}


            {/*ответ банка из архива*/}
            {info?.archiveResponse?.documentsList &&
            <Panel header="Відповідь на нотаріальний запит" key="1" className="panel1" >
              {info?.archiveResponse?.documentsList?.map((data) => {
                return <div className="download-section">
                  <div className='download-container'>
                    <p style={{fontSize: "16px"}}>{data?.documentInfo?.documentName}</p>
                    <Tooltip title="Завантажити файл" placement="right" color="#DCE123">
                      <div
                        className='download-button'
                        onClick={() => downloadFromArchiveHandler(
                          data?.documentInfo?.documentDownloadUrl,
                          data?.documentInfo?.documentName)}>
                        <SaveOutlined style={{fontSize: "1rem"}}/>
                      </div>
                    </Tooltip>
                  </div>
                  {data && data.documentInfo && data?.documentInfo?.dsDocDownloadUrl &&
                    <div className='download-container'>
                    <p style={{fontSize: "16px"}}>{data?.documentInfo?.documentName +".p7s"}</p>
                    <Tooltip title="Завантажити файл" placement="right" color="#DCE123">
                      <div
                        className='download-button'
                        onClick={() => downloadFromArchiveHandler(
                          data?.documentInfo?.dsDocDownloadUrl,
                          data?.documentInfo?.documentName +".p7s")}>
                        <SaveOutlined style={{fontSize: "1rem"}}/>
                      </div>
                    </Tooltip>
                  </div>}
                </div>})}
            </Panel>}
            <Panel header="Деталі нотаріального запиту" key="2" className="panel2">
              <div className="subtitle"><span>Персональна інформація вкладника</span></div>
              <dl>
                <dd>Дата народження:</dd>
                <dt>{info?.notaryRequestInfo && moment(info?.notaryRequestInfo?.dateBirth).parseZone().format(DATE_FORMAT_YEAR) }</dt>
              </dl>

              <dl>
                <dd>Дата набуття вкладником статусу (померлий/БВО/ОЗБОО):</dd>
                <dt>{info?.notaryRequestInfo &&  moment(info?.notaryRequestInfo?.dateDeath).parseZone().format(DATE_FORMAT_YEAR) }</dt>
              </dl>

              <dl>
                <dd>ПІБ вкладника:</dd>
                <dt>{(info?.notaryRequestInfo?.lastName|| "")+" "+(info?.notaryRequestInfo?.firstName || "")+" "+(info?.notaryRequestInfo?.middleName || "")}</dt>
              </dl>

              <dl>
                <dd>Серія паспорту:</dd>
                <dt>{info?.notaryRequestInfo?.passportSerial}</dt>
              </dl>

              <dl>
                <dd>Номер паспорту/ID паспорту:</dd>
                <dt>{info?.notaryRequestInfo?.passportNumber}</dt>
              </dl>

              <dl>
                <dd>Номера рахунків:</dd>
                <dt>{info?.notaryRequestInfo?.accountList?.map((item)=>item+" ")}</dt>
              </dl>

              <dl>
                <dd>
                  <Tooltip title="Реєстраційний номер облікової картки платника податків">
                  РНОКПП:
                    </Tooltip>
                </dd>
                <dt>{info?.notaryRequestInfo?.ipn}</dt>
              </dl>

              <div className="subtitle"><span>Фактична адреса вкладника</span></div>
              <dl>
                <dd>Індекс:</dd>
                <dt>{info?.notaryRequestInfo?.actualAddress?.indexNumber}</dt>
              </dl>

              <dl>
                <dd>Область:</dd>
                <dt>{info?.notaryRequestInfo?.actualAddress?.regionName}</dt>
              </dl>

              <dl>
                <dd>Район:</dd>
                <dt>{info?.notaryRequestInfo?.actualAddress?.districtName}</dt>
              </dl>

              <dl>
                <dd>Населений пункт:</dd>
                <dt>{info?.notaryRequestInfo?.actualAddress?.localityName}</dt>
              </dl>

              <dl>
                <dd>Вул., Просп., Б-р:</dd>
                <dt>{info?.notaryRequestInfo?.actualAddress?.streetName}</dt>
              </dl>

              <dl>
                <dd>№ буд., д/в:</dd>
                <dt>{info?.notaryRequestInfo?.actualAddress?.houseNumber}</dt>
              </dl>

              <dl>
                <dd>№ корп., секц.:</dd>
                <dt>{info?.notaryRequestInfo?.actualAddress?.sectionNumber}</dt>
              </dl>

              <dl>
                <dd>№ кв., кімню., оф.:</dd>
                <dt>{info?.notaryRequestInfo?.actualAddress?.apartmentNumber}</dt>
              </dl>

              <dl>
                <dd>Примітка:</dd>
                <dt>{info?.notaryRequestInfo?.actualAddress?.note}</dt>
              </dl>

              <div className="subtitle"><span>Юридична адреса вкладника</span></div>

              <dl>
                <dd>Індекс:</dd>
                <dt>{info?.notaryRequestInfo?.legalAddress?.indexNumber}</dt>
              </dl>

              <dl>
                <dd>Область:</dd>
                <dt>{info?.notaryRequestInfo?.legalAddress?.regionName}</dt>
              </dl>

              <dl>
                <dd>Район:</dd>
                <dt>{info?.notaryRequestInfo?.legalAddress?.districtName}</dt>
              </dl>

              <dl>
                <dd>Населений пункт:</dd>
                <dt>{info?.notaryRequestInfo?.legalAddress?.localityName}</dt>
              </dl>

              <dl>
                <dd>Вул., Просп., Б-р:</dd>
                <dt>{info?.notaryRequestInfo?.legalAddress?.streetName}</dt>
              </dl>

              <dl>
                <dd>№ буд., д/в:</dd>
                <dt>{info?.notaryRequestInfo?.legalAddress?.houseNumber}</dt>
              </dl>

              <dl>
                <dd>№ корп., секц.:</dd>
                <dt>{info?.notaryRequestInfo?.legalAddress?.sectionNumber}</dt>
              </dl>

              <dl>
                <dd>№ кв., кімню., оф.:</dd>
                <dt>{info?.notaryRequestInfo?.legalAddress?.apartmentNumber}</dt>
              </dl>

              <dl>
                <dd>Примітка:</dd>
                <dt>{info?.notaryRequestInfo?.legalAddress?.note}</dt>
              </dl>

              <div className="subtitle"><span>Вкладення</span></div>
              {info?.archive?.documentsList ?
                /*если есть архив, качаем файлы из архива*/
                  info?.archive?.documentsList?.map((data) => {
                    return <div className='download-section'>
                      <div className='download-container'>
                        {fileTypeToTextConverter(data?.documentInfo?.documentName)}
                        <p style={{fontSize: "16px"}}>{data?.documentInfo?.documentName}</p>
                        <Tooltip title="Завантажити файл" placement="right" color="#DCE123">
                          <div
                            className='download-button'
                            onClick={() => downloadFromArchiveHandler(
                              data?.documentInfo?.documentDownloadUrl,
                              data?.documentInfo?.documentName)}>
                            <SaveOutlined style={{fontSize: "1rem"}}/>
                          </div>
                        </Tooltip>
                      </div>
                      {data?.documentInfo?.dsDocDownloadUrl &&
                        <div className='download-container'>
                          {fileTypeToTextConverter(data?.documentInfo?.documentName)}
                        <p style={{fontSize: "16px"}}>{data?.documentInfo?.documentName +".p7s"}</p>
                        <Tooltip title="Завантажити файл" placement="right" color="#DCE123">
                          <div
                            className='download-button'
                            onClick={() => downloadFromArchiveHandler(
                              data?.documentInfo?.dsDocDownloadUrl,
                              data?.documentInfo?.documentName +".p7s")}>
                            <SaveOutlined style={{fontSize: "1rem"}}/>
                          </div>
                        </Tooltip>
                      </div>}
                    </div>
                  })
                  :
                  // если нет архива, тянем из стандартного апи
                  info?.packageInInfo?.files?.map((data) => {
                    return <div className='download-container'>
                      {fileTypeToTextConverter(data?.documentInfo?.documentName)}
                      <p style={{fontSize: "16px"}}>{data?.fileInfo?.fileName}</p>
                      <Tooltip title="Завантажити файл" placement="right" color="#DCE123">
                        <div
                          className='download-button'
                          onClick={() => downloadHandler(
                            info?.packageInInfo?.spSiteUrl,
                            info?.packageInInfo?.spFolderServerRelativeUrl,
                            data?.fileInfo?.fileName)}>
                          <SaveOutlined style={{fontSize: "1rem"}}/>
                        </div>
                      </Tooltip>
                    </div>
                  })
              }

              {(( !info?.archive) && ( !info?.packageInInfo && !info?.packageInInfo?.files)) &&
                <div style={{display:"flex", flexDirection:"column", width:"100%", alignItems:"center"}}>
                  <div className="ant-empty-image" style={{display:"flex"}}>
                    <svg className="ant-empty-img-simple"
                         width="64"
                         height="41"
                         viewBox="0 0 64 41"
                         xmlns="http://www.w3.org/2000/svg">
                      <g transform="translate(0 1)"
                         fill="none"
                         fill-rule="evenodd">
                        <ellipse className="ant-empty-img-simple-ellipse" cx="32" cy="33" rx="32" ry="7"></ellipse>
                        <g className="ant-empty-img-simple-g" fill-rule="nonzero">
                          <path d="M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"></path>
                          <path d="M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z" className="ant-empty-img-simple-path"></path>
                        </g>
                      </g>
                    </svg>
                  </div>
                  <div className="ant-empty-description"  style={{display:"flex", fontSize:"14px", marginBottom:"1rem"}}>Інформація відсутня</div>
                </div>
              }

            </Panel>
          </Collapse>
        </Col>
      </Row>
    </div>
  );
};


export default RequestDetails;